import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Image from 'common/src/components/Image';
import Logo from 'common/src/components/UIElements/Logo';
import Heading from 'common/src/components/Heading';
import Container from 'common/src/components/UI/Container';
import FooterArea, {
  WidgetArea,
  MenuArea,
  Menu,
  MenuItem,
  CopyrightText,
} from './footer.style';

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      appClassicJson {
        footer {
          logo {
            publicURL
          }
          menu {
            id
            link
            text
          }
          widgets {
            id
            icon {
              publicURL
            }
            title
            description
          }
        }
      }
    }
  `);
  const { logo, menu, widgets } = data.appClassicJson.footer;

  const date = new Date();
  const year = date.getFullYear();

  return (
    <FooterArea>
      <Container>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
          }}
        >
          <div style={{ color: '#bbb' }} className="address">
            <p
              style={{ fontSize: '30px', marginBottom: '40px', color: 'white' }}
            >
              BlueReaction
            </p>
            <p style={{ margin: '8px 0' }}>Νέες Καρυές</p>
            <p style={{ margin: '8px 0' }}>Λάρισα, 41500</p>
            <p style={{ margin: '8px 0' }}>Ελλάδα</p>
            <p style={{ margin: '8px 0' }}>Αρ. ΓΕΜΗ: 159920740000</p>
            <p style={{ margin: '8px 0' }}>Εταιρικό κεφάλαιο: 300,00€</p>
          </div>
          <div style={{ width: '370px', color: '#bbb' }}>
            <p style={{ margin: '8px 0' }}>
              Νικόλαος Πουλτσίδης - ΔΙΑΧΕΙΡΙΣΤΗΣ
            </p>
            <p style={{ margin: '8px 0' }}>Σιμωνίδου 6 – 17456 ΑΛΙΜΟΣ</p>
            <p style={{ margin: '8px 0' }}>
              Κεφαλαιακές εισφορές, ποσοστό 100% του εταιρικού κεφαλαίου
            </p>
          </div>
        </div>
        <CopyrightText>
          &#169; {year} BlueReaction. All rights reserved.
        </CopyrightText>
      </Container>
    </FooterArea>
  );
};

export default Footer;
